import objectToQueryString from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getCommCodes: param => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getPartsInfo: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.partsNo !== undefined || searchParams.useYn !== undefined) {
			queryStr = objectToQueryString({
				partsNo: searchParams.partsNo,
				useYn: searchParams.useYn,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/partsInfo/v1/partsInfo` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	postPartsInfo: param => {
		//console.log('debug', param);
		return client
			.post(`${BASE_URL}/partsInfo/v1/status/${param.status}/partsInfo`, param.data)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
